import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Features } from "./components/Features";
import { Gallery } from "./components/Gallery";
import { Amenities } from "./components/Amenities";
import { Location } from "./components/Location";
import { Lifestyle } from "./components/Lifestyle";
import { Booking } from "./components/Booking";
import { Trust } from "./components/Trust";
import { Footer } from "./components/Footer";
import AdminDashboard from "./pages/AdminDashboard";

const Home = () => {
  return (
    <div>
      <Navigation />
      <Hero />
      <About />
      <Features />
      <Gallery />
      <Amenities />
      <Location />
      <Lifestyle />
      <Booking />
      <Trust />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
